import { FC } from 'react';
import { PageTitle, PageLink } from '../../../../rbts/layout/core';
import { Vista } from './components/Vistas';

const ReporteVentas: FC = () => {
  const widgetsBreadCrumbs: Array<PageLink> = [
    {
      title: 'Reportes',
      path: '/reportes/ventas',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={widgetsBreadCrumbs}>{`${'Ventas'}`}</PageTitle>
      <Vista />
    </>
  );
};

export { ReporteVentas };
